import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { ContentTemplate, HeaderTemplate, Progress, Stepper, TitleHeader } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import ExamSchoolingDetailsFormSPERS from '../../../../modules/examRegistration/components/nonNationalExam/spers/ExamSchoolingDetailsForm';
import NonNationalExamTypeUuidDisplay from '../NonNationalExamTypeUuidDisplay';
import { useGetNonNationalExamSchoolingDetails } from '../../../../api-refactored/non-national-exam-registration/useGetNonNationalExamSchoolingDetails';
import { useGetCountry } from '../../../../api-refactored/non-national-exam-registration/useGetCountry';
import { AdmissionExamLevelResponse } from '../../../../api/candidate/exam/model';
import { candidateService } from '../../../../api';
import VacancyExpiredModal from '../VacancyExpiredModal';
import { useGetPassportDisabled } from '../../../../api-refactored/non-national-exam-registration/useGetPassportDisabled';
import { NonNationalExamNavigationContext } from '../../../../routes/ExamRoute';
import { NonNexPassportDisableContext } from '../../../../routes/RootRouter';

const useStyles = makeStyles()((theme) => ({
  stepper: {
    position: 'relative',
    [theme.breakpoints.up('xl')]: {
      left: '-10%',
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      left: '-10%',
    },
    [theme.breakpoints.between('md', 'xl')]: {
      left: '-2.5%',
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      left: '-2.5%',
    },
    [theme.breakpoints.down('md')]: {
      left: '-3%',
    },
  },
}));

interface ExamSchoolingDetailsPageProps {
  routeSteps: { label: string | JSX.Element; disabled?: boolean }[];
  isOpsAdmin?: boolean;
}

interface ILocationState {
  examType: string;
  examTitle: string;
  isSupplementary: boolean;
}

interface ExamSchoolingDetailsParams {
  uuid: string;
}

const SpersExamSchoolingDetails = ({
  routeSteps,
  isOpsAdmin = false,
}: ExamSchoolingDetailsPageProps) => {
  const location = useLocation<ILocationState>();
  const { state } = location;
  const { t } = useTranslation();
  const { uuid } = useParams<ExamSchoolingDetailsParams>();
  const { classes } = useStyles();
  const examTitle =
    t('exam->>RegisterExam.RegisterForAnExam') +
    (state?.isSupplementary ? ` - ${t('exam->>Instructions.Supplementary')}` : '');
  const [isSuccessExamSchoolingDetails, setIsSuccessExamSchoolingDetails] = useState<boolean>(
    false
  );
  const [examTypesData, setExamTypesData] = useState<AdmissionExamLevelResponse>();
  const [isPassportDisabled, setIsPassportDisabled] = useState<boolean>(false);
  const nonNexPassportDisableContext = useContext(NonNexPassportDisableContext);

  const { data: examSchoolingDetailsData } = useGetNonNationalExamSchoolingDetails({
    uuid,
    onSuccess: () => {
      setIsSuccessExamSchoolingDetails(true);
    },
  });

  const { data: birthCountryData } = useGetCountry();

  candidateService.exam.candidate.useGetAdmissionExamLevel(state.examType, {
    onSuccess: (res) => {
      setExamTypesData(res);
    },
  });

  useGetPassportDisabled({
    onSuccess: (res) => {
      setIsPassportDisabled(true);
      console.log(res);
      nonNexPassportDisableContext.setIsPassportDisabled(res);
    },
  });

  return (
    <>
      <TitleHeader title={isOpsAdmin ? t('exam->>NonNationalExam.ReviewApplication') : examTitle} />
      <HeaderTemplate>
        <NonNationalExamTypeUuidDisplay nonExamType={state?.examTitle || '-'} enableApi={false} />
        <Stepper className={classes.stepper} activeStep={1} steps={routeSteps} />
      </HeaderTemplate>
      {birthCountryData && isSuccessExamSchoolingDetails && examTypesData ? (
        <ExamSchoolingDetailsFormSPERS
          examSchoolingDetailsData={examSchoolingDetailsData}
          birthCountryData={birthCountryData}
          examTypesData={examTypesData}
          isOpsAdmin={isOpsAdmin}
        />
      ) : (
        <ContentTemplate transparent continuous>
          <Progress color="secondary" />
        </ContentTemplate>
      )}
      {!isOpsAdmin && <VacancyExpiredModal uuid={uuid} />}
    </>
  );
};

export default SpersExamSchoolingDetails;
